import { flowRight, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import FollowUserButtonSecure from '../../containers/follow-user-button-secure';
import PublicProfileActions from '../../containers/public-profile-actions';
import ProfileActionsButton from '../../components/profile-actions-button';
import UserAvatarImage from '../../components/user-avatar-image';
import UserBadge from '../../components/user-badge';
import Button from '../../components/button';
import { VerticalSeparator } from '../separator';
import resolveUserImage from '../../services/resolve-user-image';
import { getFollowersCount, getPostsCount } from '../../services/counters';
import withAuth from '../../hoc/with-auth';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withEnvironment from '../../hoc/with-environment';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './member-list-item-desktop.scss';

const getStyle = src => ({
  backgroundImage: src && `url(${src})`,
});

const UserProfileCover = ({ user }) => <div className={styles.cover} style={getStyle(resolveUserImage(user.cover))}/>;

UserProfileCover.propTypes = {
  user: PropTypes.object.isRequired,
};

const MemberListItemDesktop = ({ borderWidth, contentFontClassName, currentUser, member, navigation: { ProfileLink, FollowersLink }, t }) => {
  const className = classNames(
    styles.container,
    contentFontClassName,
    'forum-text-color',
    'forum-card-background-color',
    'forum-card-border-color',
    'member-list-item'
  );
  const isCurrentUser = get(currentUser, '_id') === member._id;

  return (
    <div className={className} style={{ borderWidth }} data-hook="member-list-item">
      <ProfileLink user={member}>
        <UserProfileCover user={member}/>
      </ProfileLink>

      <UserAvatarImage className={styles.avatar} type="member" user={member} component={ProfileLink}/>

      <div className={styles.details}>
        <ProfileLink className={classNames(styles.name, 'button-hover-color')} user={member}>
          {member.name} <UserBadge user={member}/>
        </ProfileLink>
        <div className={styles.date}>
          {t('member-list-item-desktop.date', { date: member.createdDate })}
        </div>
      </div>

      <div className={styles.stats}>
        <ProfileLink className={classNames(styles.statsGroup, 'button-hover-color')} user={member}>
          <div className={styles.statsNumber}>
            {getPostsCount(member)}
          </div>
          <div className={styles.statsText}>
            {t('member-list-item-desktop.posts-stats', { count: getPostsCount(member) })}
          </div>
        </ProfileLink>
        <VerticalSeparator/>
        <FollowersLink className={classNames(styles.statsGroup, 'button-hover-color')} user={member}>
          <div className={styles.statsNumber}>
            {getFollowersCount(member)}
          </div>
          <div className={styles.statsText}>
            {t('member-list-item-desktop.followers-stats', { count: getFollowersCount(member) })}
          </div>
        </FollowersLink>
      </div>

      <div className={styles.actions}>
        {!isCurrentUser &&
          <FollowUserButtonSecure user={member}>
            <PublicProfileActions triggerButton={ProfileActionsButton} user={member}/>
          </FollowUserButtonSecure>}
        {isCurrentUser &&
          <Button component={ProfileLink} user={member}>
            {t('member-list-item-desktop.my-profile')}
          </Button>}
      </div>
    </div>
  );
};

MemberListItemDesktop.propTypes = {
  borderWidth: PropTypes.number,
  contentFontClassName: PropTypes.string,
  currentUser: PropTypes.object,
  member: PropTypes.object.isRequired,
  navigation: PropTypes.object,
  t: PropTypes.func,
};

export default flowRight(
  withAuth,
  withCardBorderWidth,
  withEnvironment({ navigation: 'navigation' }),
  withFontClassName,
  withTranslate
)(MemberListItemDesktop);



// WEBPACK FOOTER //
// ./app/components/member-list-item/member-list-item-desktop.js